import React from "react";
import { Line } from "recharts";
import type { GapBridge } from "../utils";

const GAP_STROKE_DASHARRAY = "6 6";

interface LineChartLinesProps<T> {
  series: Array<{ key: keyof T; label: string; color?: string }>;
  strokeWidth?: number;
  visibleSeries?: Record<string, boolean>;
  gapBridges?: GapBridge[];
}

export const LineChartLines = <T,>({
  series,
  strokeWidth = 2,
  visibleSeries,
  gapBridges = [],
}: LineChartLinesProps<T>): React.ReactElement => {
  const isHidden = (key: string) => visibleSeries?.[key] === false;
  const colorOf = (seriesKey: string) =>
    series.find((s) => String(s.key) === seriesKey)?.color;

  return (
    <>
      {gapBridges.map((bridge) => (
        <Line
          activeDot={false}
          dataKey={bridge.dataKey}
          dot={false}
          hide={isHidden(bridge.seriesKey)}
          isAnimationActive={false}
          key={bridge.dataKey}
          legendType="none"
          stroke={colorOf(bridge.seriesKey)}
          strokeDasharray={GAP_STROKE_DASHARRAY}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={strokeWidth}
          tooltipType="none"
          type="linear"
        />
      ))}
      {series.map((s) => (
        <Line
          animationDuration={750}
          dataKey={String(s.key)}
          dot={true}
          hide={isHidden(String(s.key))}
          isAnimationActive={true}
          key={String(s.key)}
          stroke={s.color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={strokeWidth}
          type="monotone"
        />
      ))}
    </>
  );
};
